export default __webpack_public_path__ + "media/images/42-882e0dcaae3b8695d5acb7b7af0bdd16.jpg";